<template>
     <el-dialog
        ref="qbill"
        title="引用销售单据"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        v-loading="loading"
        width="70%">
        <ly-table :config="orderConfig" :head="orderHead" :data="orderList" @change="billChange"></ly-table>
        <div class="tr" v-if="pageTotal > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :page-count="pageTotal"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <ly-table :config="productConfig" :head="productHead" :data="productList" @change="productChange"></ly-table>
        <template slot='footer'>
        <div>
            <div class="flex">
                <el-button type="primary" @click="changeProductDone">添加选中的</el-button>
                <div class="f1 tr">
                    <div class="quote-bill-search">
                        <el-input placeholder="输入关键字" v-model="productKeyword" class="input-with-select">
                            <el-button slot='append' icon="el-icon-search" @click="queryProduct"> 搜索</el-button>
                        </el-input>
                    </div>
                </div>
            </div>
        </div>
        </template>
     </el-dialog>
</template>
<script>
    import LyTable from '@c/table'
    export default {
        name: 'LyQuoteBill',
        components: {
            LyTable
        },
        data () {
            return {
                loading: false,
                dialogVisible: false,
                orderPage: 1,
                orderConfig: {
                    isCheckbox: true,
                    isNumber: true,
                    height: 200
                },
                productConfig: {
                    isCheckbox: true,
                    isNumber: true,
                    height: 250
                },
                pageTotal: 0,
                orderList: [],
                orderHead: [
                    {
                        "prop": "transaction_no_display",
                        "width": "150",
                        "label": "单据号"
                    }, {
                        "prop": "shangyou_no",
                        "width": "100",
                        "label": "关联单据号"
                    }, {
                        "prop": "work_time",
                        "width": "100",
                        "label": "日期"
                    }, {
                        "prop": "customer_name",
                        "width": "120",
                        "label": "客户"
                    }, {
                        "prop": "warehouse_name",
                        "width": "120",
                        "label": "目标仓库"
                    }, {
                        "prop": "change",
                        "label": "已选中(行)"
                    }, {
                        "prop": "zhaiyao",
                        "width": "200",
                        "label": "摘要"
                    }
                ],
                changeOrderIds: [],
                productKeyword: '',
                productList: [],
                productHead: [
                    {
                        "prop": "product_code",
                        "width": "120",
                        "label": "货品编码"
                    }, {
                        "prop": "full_name",
                        "width": "200",
                        "label": "货品名称"
                    }, {
                        "prop": "product_unit",
                        "label": "单位"
                    }, {
                        "prop": "price",
                        "label": "单据内单价"
                    }, {
                        "prop": "quantity",
                        "label": "单据内数量"
                    }, {
                        "prop": "xiaoji",
                        "label": "小计金额"
                    }, {
                        "prop": "reference_num",
                        "label": "已引用数量"
                    }, {
                        "prop": "remain_num",
                        "label": "可引用数量"
                    }
                ],
                changeProductList: [],
                customer_id: 0,
                checkProduct: []
            }
        },
        methods: {
            open (customerId) {
                this.customer_id = customerId
                this.dialogVisible = true
                this.quetoList()
            },
            /**
             * 分页的点击
             */
            handleCurrentChange (val) {
                this.orderPage = val
                this.quetoList()
            },
            /**
             * 请求引用单据
             */
            quetoList () {
                this.loading = true
                this.$api.query('manage/purchaseQuoteList' , {
                    page: this.orderPage,
                    yinyong_type: 1,
                    type: 23,
                    customer_id: this.customer_id
                }).then((rs) => {
                    this.loading = false
                    this.pageTotal = rs.total
                    rs.data.forEach(el => {
                        el.change = 0
                    })
                    this.orderList = rs.data
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            queryProduct () {
                this.loading = true
                this.$api.create('manage/purchaseQuoteInfo' , {
                    ids: this.changeOrderIds,
                    yinyong_type: 1,
                    type: 23,
                    keyword: this.productKeyword
                }).then((rs) => {
                    this.loading = false
                    let pList = rs.filter(el => el.remain_num > 0)
                    pList.forEach(el => {
                        if (el.bill_type === 2) {
                            el.price = -parseFloat(el.price).toFixed(2)
                            el.xiaoji = -parseFloat(el.xiaoji).toFixed(2)
                        }
                    })
                    this.productList = pList
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 单据的选择
             */
            billChange (val) {
                this.changeOrderIds = []
                val.forEach(el => {
                    this.changeOrderIds.push(el.id)
                });
                this.queryProduct()
            },
            /**
             * 选中的货品
             */
            productChange (val) {
                this.changeProductList = val
            },
            /**
             * 添加选中的
             */
            changeProductDone () {
                if (this.changeProductList.length > 0) {
                    // 引用的时候，引用数量为可引用数量   2021-7-16 by welpher
                    this.changeProductList.forEach(el => {
                        el.quantity = el.remain_num
                    })
                    this.$emit('change',this.changeProductList)
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    })
                    this.checkProduct = this.checkProduct.concat(this.changeProductList)
                    // 计算单据已经选中的数量
                    this.checkProduct.forEach(el => {
                        for (let i = 0, len = this.orderList.length; i < len; i++) {
                            if (el.yinyong_detail_id === this.orderList[i]['id']) {
                                let num = this.orderList[i]['change'] + 1
                                this.$set(this.orderList[i],'change',num)
                            }
                        }
                    })
                }
            }
        }
    }
</script>

<style>
.quote-bill-search {
    width: 200px;
    display: inline-block;
}
</style>
